import { render } from "../views/main.html?vue&type=template&id=524bb5ca&ts=true&external"
import script from "../scripts/main.ts?vue&type=script&lang=ts&external"
export * from "../scripts/main.ts?vue&type=script&lang=ts&external"

import "../css_builds/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "524bb5ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('524bb5ca', __exports__)) {
    api.reload('524bb5ca', __exports__)
  }
  
  module.hot.accept("../views/main.html?vue&type=template&id=524bb5ca&ts=true&external", () => {
    api.rerender('524bb5ca', render)
  })

}


export default __exports__